export const getEnv = () => {
  if (typeof window !== 'undefined') {
    const url = window.location.hostname;
    if (url.includes('dev') || url.includes('localhost')) {
      return 'DEV';
    }
    return 'PROD';
  }
};
